export default "__VITE_ASSET__2CQES_Yb__"